import { m } from 'framer-motion';
import { styled } from '@linaria/react';
import { COLORS, typographyStyles } from '@livecommerce/design-system';

import _NavigationDropdown from 'components-v3/NavigationDropdown/index.jsx';
import { SIDEBAR_WIDTH, EXPANDED_SIDEBAR_WIDTH, GRADIENT_HEIGHT } from '../ProductsNavigation/constants.js';

export const { getBodyText, getLargeHeadline } = typographyStyles;

const bodyText14 = getBodyText(14);
const bodyText12 = getBodyText(12);

export const SidebarContainer = styled.div`
  display: grid;
  grid-template-columns: ${SIDEBAR_WIDTH}px ${EXPANDED_SIDEBAR_WIDTH}px;
`;

export const AbsoluteWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 8px;
    background-color: rgba(0, 0, 0, 0);
    border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 6px;
  }
  &::-webkit-scrollbar-track {
    border: 8px solid transparent;
    background-clip: padding-box;
  }
  &:hover {
    &::-webkit-scrollbar {
      background-color: rgba(0, 0, 0, 0.4);
    }
    &::-webkit-scrollbar-thumb {
      border-color: rgba(0, 0, 0, 0.4);
    }
  }
`;

export const ScrollableNavigationItems = styled.div`
  flex-grow: 1;
  position: relative;
  width: 100%;
  overflow: hidden;
  &:after {
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 25px;
    min-height: 25px;
    pointer-events: none;
    z-index: 2;
    content: '';
    background: linear-gradient(180deg, rgba(29, 29, 29, 0) 0%, #1D1D1D 100%);
  }
`;

export const NavigationContainer = styled.ul`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  list-style-type: none;
  padding: 0 0 ${GRADIENT_HEIGHT}px 0;
  margin: 0 0 auto 0;
  z-index: 1;
  gap: 12px;
`;

export const NavigationDropdown = m(_NavigationDropdown);

export const InteractiveElementButton = styled.button`
  position: relative;
  padding: 0;
  border: none;
  border-radius: 6px;
  width: 48px;
  height: 48px;
  background-color: ${(props) => (props.active ? props.activeBackgroundColor : props.backgroundColor)};
  color: ${(props) => (props.active ? props.activeColor : props.color)};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.activeBackgroundColor};
    color: ${(props) => props.activeColor};
  }
`;

export const SidebarContentArea = styled.div`
  display: flex;
  width: ${(props) => (props.isSidebarExpanded ? EXPANDED_SIDEBAR_WIDTH + SIDEBAR_WIDTH : SIDEBAR_WIDTH)}px;
  height: 100%;
  flex: 1;
  gap: 16px;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  grid-area: 1 / 1 / 2 / 2;
  z-index: 2;
`;

export const InteractiveElementContainer = styled.div`
  flex-shrink: 0;
  width: 74px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
  z-index: 2;
`;

export const SubMenuWrapper = styled.div`
  position: absolute;
  top: ${(props) => (props.align === 'top' ? '0' : 'auto')};
  bottom: ${(props) => (props.align === 'bottom' ? '0' : 'auto')};
  left: 100%;
  padding-left: 15px;
  width: ${EXPANDED_SIDEBAR_WIDTH}px;
`;

export const ScrollArrow = styled.div`
  flex-shrink: 0;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 74px;
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  &:hover {
    transform: translateY(6px);
  };
`;

export const SkeletonNavigationListItem = styled.li`
  display: flex;
  flex-direction: column;
  align-self: center;
  gap: 9px;
  margin-bottom: 3px;

  & > div {
    min-height: 0;
  }
`;

export const LanguageSelector = styled.button`
  display: flex;
  border: none;
  border-radius: 6px;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  text-transform: uppercase;
  color: ${COLORS.white};
  background-color: transparent;
  padding-right: 0;
  padding-left: 0;
  width: 40px;
  height: 40px;
  font-weight: ${bodyText14.fontWeight};
  font-size: ${(props) => (props.isLatin ? bodyText14.fontSize : bodyText12.fontSize)};
  font-family: ${bodyText14.fontFamily};
  line-height: ${bodyText14.lineHeight};
  &:hover {
    text-decoration: underline;
  }
`;
